import { formValidation } from '@vfde-brix/ws10/validation';
import * as avcActions from 'Container/AvailabilityCheck/action';
import * as appActions from 'Container/App/action';
import { mountButton } from '../../../components/button';
import { mountFormElement } from '../../../components/formElement';
import { Inputs } from '../enum';
import { FormId } from '../../../enums/elementId';
import { CITY_VALIDATOR, NUMBER_VALIDATOR, STREET_VALIDATOR } from '../constants';
import { FormElement } from '@vfde-brix/ws10/form-element';
import { IInputConfiguration, LooseObject } from '../../../interface';

const mapDispatch = {
    ...avcActions,
    ...appActions,
};

type Actions = typeof mapDispatch;

export const mountAvcForm = (actions: Actions) => {
    const formFields: FormElement[] = [];
    let returnForm: LooseObject = {};

    const cityOnChange = (_event: Event, value: string) => actions.setInput(Inputs.CITY, value);
    const streetOnChange = (_event: Event, value: string) => actions.setInput(Inputs.STREET, value);
    const numberOnChange = (_event: Event, value: string) => actions.setInput(Inputs.NUMBER, value);
    const selectOnChange = (_event: Event, value: string) => actions.setForm(+value);

    const inputConfigurations: IInputConfiguration[] = [
        {
            name: Inputs.CITY,
            id: FormId.CITY,
            onChange: cityOnChange,
            validation: CITY_VALIDATOR,
        },
        {
            name: Inputs.STREET,
            id: FormId.STREET,
            onChange: streetOnChange,
            validation: STREET_VALIDATOR,
        },
        {
            name: Inputs.NUMBER,
            id: FormId.NUMBER,
            onChange: numberOnChange,
            validation: NUMBER_VALIDATOR,
        },
    ];

    for (const { id, onChange, validation, name } of inputConfigurations) {
        const formElement = mountFormElement(id, onChange, validation);
        if (formElement) {
            formFields.push(formElement);
            returnForm[name as keyof LooseObject] = formElement;
        }
    }

    const submit = mountButton(FormId.SUBMIT, actions.checkAddress);
    returnForm.submit = submit;

    formValidation({
        formFields,
        submitButton: submit,
    }, true, true);

    // select is not part of the form validation
    returnForm.select = mountFormElement(FormId.SELECT, selectOnChange, []);

    return returnForm;
};
